<template>
  <div class="edit-booths-wrap">
    <div class="form-wrap">
      <div class="fullname-wrap" v-if="location.ltp_code === 'bth'">
        <label for="fullName">Full name</label>
        <input id="fullName" type="text" v-model="fullName" :disabled="location.loc_id">
      </div>
      <div class="name-wrap" v-if="location.ltp_code !== 'info'">
        <label for="name">Name</label>
        <input id="name" type="text" v-model="name" :disabled="location.loc_id">
      </div>
      <div class="floor-wrap" v-if="location.ltp_code === 'bth' && !location.loc_id">
        <label>Select Floor:</label>
        <select v-model="floor">
          <option v-for="floor in floors"
            :key="floor.loc_id"
            :value="floor"
          >{{floor.loc_name}}</option>
        </select>
      </div>
      <clickable-wrapper
        :location="location"
        :image="image"
        :content="mappedContent"
        @set-image="setImage"
        @reset-image="setImageFromContent"
        @soft-save-content="getNewContent"
        @check-soft-delete="checkIfContentIsSoftSaved"
        @delete-new-content-array="contentItemsToSave=[]"
        @group-delete-content="appendContentItemsToDelete"
        @revert-group-delete-content="contentItemsToDelete=[]"
      ></clickable-wrapper>
      <div class="buttons">
        <button @click="addOrEditLocation" class="add-button">{{location.loc_id? 'Edit' : 'Add'}}</button>
        <button 
          v-if="location.loc_id && location.ltp_code !== 'intr' && location.ltp_code !== 'info'" 
          @click="confirmAction(deleteLocation, 'Are you sure you want to delete this location?')"
        >Delete Location</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import ClickableWrapper from './ClickableWrapper'
import AdminMixin from '../../../views/admin-pages/adminMixin'
export default {
  mixins: [
    AdminMixin
  ],
  components: {
    ClickableWrapper
  },
  props: {
    location: Object,
    floors: Array
  },
  data () {
    return {
      image: '',
      oldImage: '',
      name: this.location.loc_id? this.location.name : '',
      fullName: '',
      floor: '',
      mappedContent: [],
      content: [],
      contentItemsToSave: [],
      contentItemToDelete: {},
      contentItemsToDelete: []
    }
  },
  computed: {
    getApis () {
      let apiObj = {};

      switch (this.location.ltp_code) {
        case 'intr':
          apiObj = {
            post: api.setIntro,
            delete: api.deleteIntro
          }
          break;
        case 'info':
          apiObj = {
            post: api.setInfo,
            delete: api.deleteInfo
          }
          break;
        case 'conf':
          apiObj = {
            post: api.setConference,
            delete: api.deleteConference
          }
          break;
        case 'intl':
          apiObj = {
            post: api.setFloor,
            delete: api.deleteFloor
          }
          break;     
        case 'bth':
          apiObj = {
            post: api.setBooth,
            delete: api.deleteBooth
          }
          break;
      }
      return apiObj;
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    async init () {
      if (this.location.loc_id) {
        this.startLoading();
          await this.getContent();
        this.stopLoading();
      }
    },
    async getContent () {
      this.content = [];
      this.mappedContent = [];
      try {
        const res = await api.getContent({
          loc_id: this.location.loc_id
        });
        this.content = res.data.res;
        this.setImageFromContent();
        this.mapContent();
      } catch (error) {
        this.handleError(error);
      }
    },
    setImageFromContent () {
      this.image = '';
      for (let i = 0; i < this.content.length; i++) {
        if (this.isContentBackgroundImage(this.content[i])) {
          this.image = `data:image/png;base64,${this.content[i].con_data}`;
          this.oldImage = this.image;
          break;
        }
      }
    },
    mapContent () {
      for (let i = 0; i < this.content.length; i++) {
        if (!this.isContentBackgroundImage(this.content[i])) {
          let contentObject = {};
          let coords = {};

          coords.top = this.content[i].clm_top;
          coords.bottom = this.content[i].clm_bottom;
          coords.left = this.content[i].clm_left;
          coords.right = this.content[i].clm_right;
          
          contentObject.coords = coords;
          contentObject.content = true; //effects styles of clickable elements
          contentObject.contentItems = {
            clm_id: this.content[i].clm_id,
            cdt_id: this.content[i].cdt_id,
            cnt_id: this.content[i].cnt_id,
            ctg_id: this.content[i].ctg_id,
            con_groups: this.content[i].con_groups,
            con_created: this.content[i].con_created,
            con_data: this.content[i].con_data,
            con_id: this.content[i].con_id,
            con_text: this.content[i].con_text,
            con_video: this.content[i].con_video
          }
          this.mappedContent.push(contentObject);
        } 
      }
    },
    isContentBackgroundImage (content) {
      if (
        !content.clm_top &&
        !content.clm_bottom &&
        !content.clm_right &&
        !content.clm_left &&
        content.con_data
      ) {
        return true;
      } else {
        return false;
      }
    },
    getNewContent (contentParams) {
      if (this.contentItemsToSave.length === 0) {
        this.contentItemsToSave.push(contentParams);
      } else {
        for (let i = 0; i < this.contentItemsToSave.length; i++) {
          if (contentParams.softSaveId) {
            if (this.contentItemsToSave[i].softSaveId === contentParams.softSaveId) {
              this.contentItemsToSave.splice(i, 1, contentParams);
              return;
            }
          } else if (contentParams.con_id) {
            if (this.contentItemsToSave[i].con_id === contentParams.con_id) {
              this.contentItemsToSave.splice(i, 1, contentParams);
              return;
            }
          }
        }
        this.contentItemsToSave.push(contentParams);
      }
    },
    async addOrEditLocation () {
      this.startLoading();
        let dynamicLocId = this.location.loc_id? this.location.loc_id : '';
        //Posting new location
        if (!this.location.loc_id) {
          dynamicLocId = await this.uploadLocationAndSetDynamicLocId();
        }

        //Posting each new content
        if (this.contentItemsToSave.length) {
          await this.uploadContent(dynamicLocId);
        }

        //Posting background image
        if (this.image !== this.oldImage) {
          await this.uploadBackgroundImage(dynamicLocId);
        }

        //If template overites previous clickable elements, delete them
        await this.deleteContents();

        this.$emit('close-modal');
        this.showSuccessMessage(this.location.loc_id? "Location Updated." : "Location Created.")
        if (!this.location.loc_id) this.$emit('get-locations');
        await this.init();
        this.contentItemsToSave = [];
        this.contentItemsToDelete = [];
      this.stopLoading();
    },
    setImage (newImage) {
      this.image = newImage;
    },
    async uploadLocationAndSetDynamicLocId () {
      try {
        const newId = await this.getApis.post({
          loc_id: this.floor.loc_id,
          loc_name: this.name,
          loc_fullname: this.fullName
        });
        return newId.data.loc_id.id;
      } catch (error) {
        this.handleError(error);
      }
    },
    async uploadBackgroundImage (dynamicLocId) {
      try {
        let imageContentId = 2;
        await this.deletePreviousBackgroundImage();
        let blobImage = await this.base64ToBlob(this.image)
        let formData = new FormData();
        formData.append("loc_id", dynamicLocId);
        formData.append("cnt_id", imageContentId);
        formData.append("con_data", blobImage);
        await api.setContent(formData);
      } catch (error) {
        this.handleError(error);
      }
    },
    async base64ToBlob (base64Image) {
      return await (await fetch(base64Image)).blob();
    },
    async deletePreviousBackgroundImage () {
      for (let i = 0; i < this.content.length; i++) {
        if (this.isContentBackgroundImage(this.content[i])) {
          try {
            await api.deleteContent({
              clm_id: this.content[i].clm_id,
              con_id: this.content[i].con_id
            });
          } catch (error) {
            this.handleError(error);
          }
        }
      }
    },
    async uploadContent (dynamicLocId) {
      for (let i = 0; i < this.contentItemsToSave.length; i++) {
        this.contentItemsToSave[i].loc_id = dynamicLocId;
        const con_id = this.contentItemsToSave[i].con_id;

        //If content item have binary data, transform it to FormData
        if (this.contentItemsToSave[i].con_data) {
          // if its html or html-modal check if binary is being sent and revert it
          if ([5, 13].includes(this.contentItemsToSave[i].cnt_id)) {
            this.contentItemsToSave[i].con_data = this.tryParseBinary(this.contentItemsToSave[i].con_data);
          }
          this.contentItemsToSave[i] = this.transformToFormData(this.contentItemsToSave[i])
        }
        
        try {
          if (con_id) {
            await api.patchContent(this.contentItemsToSave[i]);
          } else {
            await api.setContent(this.contentItemsToSave[i]);
          }
        } catch (error) {
          this.handleError(error)
        }
      }
    },
    transformToFormData (params) {
      let formData = new FormData();
      for (const key in params) {
        formData.append(key, params[key]);
      }
      return formData;
    },
    tryParseBinary (val) {
      try {
        return this.b64DecodeUnicode(val);
      } catch (error) {
        return val;
      }
    },
    b64DecodeUnicode(str) {
      // Going backwards: from bytestream, to percent-encoding, to original string.
      return decodeURIComponent(atob(str).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    },
    async deleteLocation () {
      this.startLoading();
        await this.deleteAllContent();
        await this.deleteAllSubContent();
        try {
          await this.getApis.delete({
            loc_id: this.location.loc_id
          });
          this.$emit('get-locations');
          this.showSuccessMessage('Location Deleted.')
        } catch (error) {
          this.handleError(error);
        }
      this.stopLoading();
    },
    async deleteAllContent () {
      for (let i = 0; i < this.content.length; i++) {
        try {
          await api.deleteContent({
            clm_id: this.content[i].clm_id,
            con_id: this.content[i].con_id
          });
        } catch (error) {
          this.handleError(error);
        }
      }
    },
    async deleteAllSubContent () {
      if (this.location.ltp_code === 'intl') {
        this.deleteBoothsOnFloorAndTheirContent();
      } else if (this.location.ltp_code === 'conf') {
        this.deleteConferenceLinks();
      }
    },
    async deleteBoothsOnFloorAndTheirContent () {
      try {
        let apiObj = {
          api: api.getBoothsOnFloor,
          params: {
            loc_id: this.location.loc_id
          }
        }
  
        const data = await this.apiCall(apiObj);
        if (data.booths) {
          for (let i = 0; i < data.booths.length; i++) {
            //get booth content
            let apiGetObj = {
              api: api.getContent,
              params: {
                loc_id: data.booths[i].loc_id
              }   
            }
            const contentData = await this.apiCall(apiGetObj);
            if (contentData.res) {
              //delete all content for one booth
              for (let j = 0; j < contentData.res.length; j++) {
                let apiDelContentObj = {
                  api: api.deleteContent,
                  params: {
                    clm_id: contentData.res[i].clm_id,
                    con_id: contentData.res[i].con_id
                  }
                }

                await this.apiCall(apiDelContentObj)
              }
            }
            //delete booth
            let apiDelObj = {
              api: api.deleteBooth,
              params: {
                loc_id: data.booths[i].loc_id
              }
            }

            await this.apiCall(apiDelObj)
          }
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    async deleteConferenceLinks () {
      try {
        //get links off all conferences
        let apiGetLinksObj = {
          api: api.getLinks,
          params: {
            stl_id: this.location.loc_id
          },
          onError: () => {}
        }
        //filter the result and get links only for this conference
        const data = await this.apiCall(apiGetLinksObj);
        let links;
        if (data) {
          links = data.links.filter(link => {
            if (link.loc_id === this.location.loc_id) return link;
          });
          //delete all links
          for (let i = 0; i < links.length; i++) {
            let apiDelLinksObj = {
              api: api.deleteLink,
              params: {
                stl_id: links[i].stl_id,
              }
            }
            await this.apiCall(apiDelLinksObj);
          }
        }
      } catch (error) {
        this.handleError(error)
      }
    },
    appendContentItemsToDelete (contentObj) {
      for (let i = 0; i < this.contentItemsToSave.length; i++) {
        if (this.contentItemsToSave[i].con_id === contentObj.con_id) {
          this.contentItemsToSave.splice(i, 1);
          break;
        }
      }
      this.contentItemsToDelete.push(contentObj)
    },
    checkIfContentIsSoftSaved (contentObj) {
      for (let i = 0; i < this.contentItemsToSave.length; i++) {
        if (this.contentItemsToSave[i].softSaveId === contentObj.contentItems.softSaveId) {
          this.contentItemsToSave.splice(i, 1);
          return;
        }
      }
    },
    async deleteContents () {
      for (let i = 0; i < this.contentItemsToDelete.length; i++) {
        try {
          await api.deleteContent({
            clm_id: this.contentItemsToDelete[i].clm_id,
            con_id: this.contentItemsToDelete[i].con_id
          });
        } catch (error) {
          this.handleError(error);
        }
      }
    }
  },
  watch: {
    location: {
      handler () {
        const isAddingNewLocation = Object.keys(this.location).length === 1;
        if (Object.keys(this.location).length !== 0 && !isAddingNewLocation && this.location.constructor === Object) {
          this.init();
          this.name = this.location.name
        }
        this.contentItemsToSave = [];
      }
    }
  }
}
</script>

<style scoped>
.buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
  width: 60%;
}
button {
  cursor: pointer;
  white-space: nowrap;
  border: none;
  padding: 8px 23px;
  border-radius: 100px;
  font-size: 13px;
  margin: 5px 10px;
  outline: none;
  min-width: 30%;
}
.add-button {
  background: var(--button-color-blue);
  color: white;
}
.form-wrap {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.name-wrap, .fullname-wrap {
  width: 60%;
  margin: 10px 0;
}
.floor-wrap {
  display: flex;
  flex-direction: column;
  margin: 20px 0;
}
.activity-wrap {
  display: flex;
  flex-direction: row;
  width: 100%;
  font-size: 20px;
}
.material-icons {
  cursor: pointer;
}
.buttons span {
  word-break: break-all;
}
</style>